module.exports = __webpack_public_path__ + "img/alipay.ac57224e.png";